import React, { useCallback } from 'react';
import { useParams, useHistory } from 'react-router-dom';

import Grid from '@mui/material/Grid';

import QuickLinksPanel from '@ts-core/components/QuickLinksPanel';
import SubjectsPanel, { useSubjectsPanel } from '@ts-core/components/SubjectsPanel';
import DashboardHeader from '@ts-core/components/DashboardHeader';

import { useQuickLinks } from 'modules/dashboard/hooks';
import { useCourse } from 'modules/courses/hooks';
import { useSubjects } from 'modules/subjects/hooks';

import TimelineContainer from '../components/Timeline/TimelineContainer';

const StudentDashboardPage = () => {
  const { courseId } = useParams<{ courseId: string }>();
  const history = useHistory();

  const quickLinks = useQuickLinks({ courseId });
  const { subjects, loading, error } = useSubjects({ courseId });
  const { course, loading: loadingCourse } = useCourse({ courseId });

  const navigateToSubject = useCallback(
    (subject: any) => {
      history.push(`/${courseId}/subjects/${subject._id}/media`);
    },
    [history, courseId]
  );

  const subjectsPanelProps = useSubjectsPanel({
    subjects,
    loading,
    error,
    onSelectLeafSubject: navigateToSubject,
  } as any);

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <DashboardHeader course={course} loading={loadingCourse} />
        </Grid>
        <Grid item xs={12} md={4}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <QuickLinksPanel quickLinks={quickLinks} />
            </Grid>
            <Grid item xs={12}>
              <SubjectsPanel {...subjectsPanelProps} />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} md={8}>
          <TimelineContainer />
        </Grid>
      </Grid>
    </>
  );
};

export default StudentDashboardPage;
